export const paintFinishes = {
    matte: {
        name: 'Matte',
        roughness: 0.8,
        metalness: 0.0,
        envMapIntensity: 0.5,
        lightIntensity: 0.3
    },
    glossy: {
        name: 'Glossy',
        roughness: 0.1,
        metalness: 0.0,
        envMapIntensity: 1.0,
        lightIntensity: 1.1
    },
    metallic: {
        name: 'Metallic',
        roughness: 0.3,
        metalness: 1.0,
        envMapIntensity: 1.2,
        lightIntensity: 1.2
    },
    anodized: {
        name: 'Anodized',
        roughness: 0.3,
        metalness: 0.8,
        envMapIntensity: 1.2,
        lightIntensity: 1.0
    }
}